import { unitization } from "helpers";
import { useAppSelector } from "redux-share/hooks";
import OnlineViewersIcon from "../../../icon-components/onlineViewerIcon";
import { shallowEqual } from 'react-redux'

const OnlineViewer = () => {

    const { onlineViewers } = useAppSelector(({ videoData: { onlineViewers } }) => ({ onlineViewers }), shallowEqual);

    return ( 
        <div className="pl-flex pl-items-center pl-justify-center pl-gap-0.5">
            <OnlineViewersIcon className="pl-w-3 pl-h-3 pl-stroke-dark-5"/>
            <div className="pl-flex pl-items-center pl-gap-0.5 pl-text-white pl-text-[12px] pl-font-normal pl-relative pl-top-[1px]">
                <div>{unitization(onlineViewers!).unit}</div>
                <div>{unitization(onlineViewers!).value}</div>
            </div>
        </div>
    )
}

export default OnlineViewer;